import { render, staticRenderFns } from "./ResourceManagementInfo.vue?vue&type=template&id=1d682011"
import script from "./ResourceManagementInfo.vue?vue&type=script&lang=js"
export * from "./ResourceManagementInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports